import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../../generic-components/Heading';
import { useStore } from '../../../../../store';
import { convertValueToUSD } from '../../../../../helpers/currency.helper';
import { DEFAULT_BILL_NUMBER } from '../consts';

export const BillInfo = () => {
  const { billData } = useStore(state => state);
  const { t } = useTranslation();
  return (
    <div className='absolute top-0 left-0 translate-x-[50px] translate-y-[80px] flex flex-col'>
      <Heading title={`${t('CREATE_BILL.BILL_INFO_NUMBER')} #${billData.billNumber || DEFAULT_BILL_NUMBER}`} className='font-metricRMedium text-bw08 text-[22px]' />
      <Heading title={`${t('CREATE_BILL.BILL_INFO_AMOUNT')} ${convertValueToUSD(Number(billData.amount) || 0, 2)}`} className='font-metricR text-bw07 text-[16px]' />
    </div>
  );
};
